module.exports = __webpack_public_path__ + "static/headerRightBg-c7d9daf4c9281ca7873963053b204599.png";